import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomTooltipComponent {
  @Input() isShown = false;
  @Input() placement = 'top';
  @Input() html = '';
  @Output() tooltipClick = new EventEmitter();

  click(event: Event) {
    this.isShown = !this.isShown;
    this.tooltipClick.emit();
    event.stopPropagation();
  }
}
